/**
 * PLayer Panel component
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

/* eslint no-path-concat: 0 */
/* eslint no-use-before-define:0*/

var Component   = require('stb-component'),
    keys        = require('stb-keys'),
    ProgressBar = require('spa-component-progress-bar'),
    Grid        = require('spa-component-grid'),
    buttonsRender = require('./player.buttons.grid.render'),
    buttons;


function Player ( config ) {
    var $buttonsWrapper,
        self = this;

    config = config || {};

    config.className = 'playerPanel ' + (config.className || '');

    config.$body = document.createElement('div');
    config.$body.className = 'body';

    Component.call(this, config);


    this.$node.appendChild(this.$bufferBar = document.createElement('div'));
    this.$bufferBar.className = 'bufferBar';

    this.$node.appendChild(this.$progressbar = document.createElement('div'));
    this.$progressbar.className = 'progressBar';

    this.$node.appendChild(this.$body);


    this.$body.appendChild(this.$leftText = document.createElement('div'));
    this.$leftText.className = 'leftText';

    this.progressBar = new ProgressBar({
        $node: this.$progressbar
    });

    this.bufferBar = new ProgressBar({
        $node: this.$bufferBar
    });

    this.$body.appendChild($buttonsWrapper = document.createElement('div'));
    $buttonsWrapper.className = 'buttonsWrapper';

    this.buttons = new Grid({
        propagate: true,
        data: [['']],
        parent: this,
        className: 'playerButtons',
        events: {
            'click:item': function ( event ) {
                if ( event.$item.data && event.$item.data.click ) {
                    event.$item.data.click();
                }
            }
        }
    });

    this.buttons.focusIndex = function ( index ) {
        return self.buttons.focusItem(self.buttons.map[0][index]);
    };

    this.buttons.$links = {};

    $buttonsWrapper.appendChild(this.buttons.$node);

    this.$body.appendChild(this.$rightText = document.createElement('div'));
    this.$rightText.className = 'rightText';

    this.init(config);
}


Player.prototype = Object.create(Component.prototype);
Player.prototype.constructor = Player;

Player.prototype.init = function ( config ) {
    buttons = {
        chM: {
            icon: 'ch-',
            click: function () { if ( config.onChannels ) { config.onChannels({direction: keys.left}); } }
        },
        prev: {
            icon: 'prev',
            click: function () { if ( config.onPrevNext ) { config.onPrevNext({direction: keys.left}); } }
        },
        rewind: {
            icon: 'rewind',
            click: function () { if ( config.onRewind ) { config.onRewind({direction: keys.left}); } }
        },
        play: {
            icon: 'playPause',
            click: function () { if ( config.onPlay ) { config.onPlay(); } }
        },
        forward: {
            icon: 'forward',
            click: function () { if ( config.onRewind ) { config.onRewind({direction: keys.right}); } }
        },
        next: {
            icon: 'next',
            click: function () { if ( config.onPrevNext ) { config.onPrevNext({direction: keys.right}); } }
        },
        chP: {
            icon: 'ch+',
            click: function () { if ( config.onChannels ) { config.onChannels({direction: keys.right}); } }
        }
    };

    this.buttons.init({
        propagate: true,
        data: [[buttons.chM, buttons.prev, buttons.rewind, buttons.play, buttons.forward, buttons.next, buttons.chP]],
        render: buttonsRender
    });


    if ( config.progressBar ) {
        this.progressBar.show();
    } else {
        this.progressBar.hide();
    }

};

/*eslint no-invalid-this:0*/

Player.prototype.focus = function () {
    this.buttons.focus();
};


// channel - btn
// prev content btn
// rewind btn
// pause btn
// forward btn
// next content btn
// channel + btn

Player.prototype.initButtons = function ( config ) {
    var buttonsArray;

    config = config || {};

    this.buttons.enabledCount = 0;
    buttons.chM.disable = !config.prevChannel;
    buttons.prev.disable = !config.prev;
    buttons.rewind.disable = !config.rewind;
    buttons.play.disable = !config.play;
    buttons.forward.disable = !config.forward;
    buttons.next.disable = !config.next;
    buttons.chP.disable = !config.nextChannel;

    buttonsArray = [buttons.chM, buttons.prev, buttons.rewind, buttons.play, buttons.forward, buttons.next, buttons.chP];
    // set all buttons to non focus
    buttonsArray.forEach(function ( button ) { button.focus = false; });
    if ( this.buttons.$focusItem && this.buttons.$focusItem.x !== undefined && !buttonsArray[this.buttons.$focusItem.x].disable ) {
        buttonsArray[this.buttons.$focusItem.x].focus = true;
    }

    this.buttons.init({
        propagate: true,
        data: [buttonsArray]
    });
};

Player.prototype.showPlayButton = function () {
    var $buttonIcon = this.buttons.$links.playPause.$icon;

    $buttonIcon.classList.remove('theme-icon-pause');
    $buttonIcon.classList.add('theme-icon-play');

};

Player.prototype.showPauseButton = function () {
    var $buttonIcon = this.buttons.$links.playPause.$icon;

    $buttonIcon.classList.add('theme-icon-pause');
    $buttonIcon.classList.remove('theme-icon-play');
};

Player.prototype.ui = {
    DEFAULT_COLOR: '#165ACA'
};

Player.prototype.colorize = function ( color ) {
    color = color || this.ui.DEFAULT_COLOR;

    this.$body.style.backgroundColor = color;
    this.progressBar.$value.style.backgroundColor = colorLuminance(color, 2.6);
};

function colorLuminance (hex, lum) { /*eslint-disable*/
    var rgb = '#',
        c, i;

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
        rgb += ('00' + c).substr(c.length);
    }

    return rgb;
}

module.exports = Player;
